import $ from 'jquery';
import Modal from 'bootstrap/js/src/modal';
import ajaxService from '../services/ajaxService';

class GroupPage {
	constructor() {
		this.form = $('#groupPageForm');

		/**
		 * Whether submitting the form is in progress
		 * @type {boolean}
		 * @private
		 */
		this.isSubmitting = false;

		this.init();
	}

	init() {
		this.initEvents();
	}

	initEvents() {
		const {form} = this,
			  selectedArrangementInput = form.find('.selectedArrangement');

		// change when to require comment input
		form.find('.selectSpecificArrangementHolder').on('change', () => {
			const showSelectedArrangementInput = $('#matchRadio_yes').is(':checked');

			selectedArrangementInput
				.toggleClass('d-none')
				.attr('required', showSelectedArrangementInput);
		});

		this.form.on('submit', (ev) => {
			this.sendFormData();

			ev.preventDefault();
		});
	}

	sendFormData() {
		if (this.isSubmitting) {
			return;
		}

		this.isSubmitting = true;

		ajaxService.sendPost({
			'url' : '/group_request/send/',
			'data': {
				'formData': Object.fromEntries(new FormData(this.form[0]))
			}
		})
			.then(({response, xhr}) => {
				const status = xhr.status || response.status;

				if (status === 201) {
					const grouppageSuccessSignupModal = document.getElementById('grouppage_success_signup');

					if (grouppageSuccessSignupModal) {
						Modal
							.getOrCreateInstance(grouppageSuccessSignupModal)
							.show();
					}

					if (response.redirectUrl) {
						setTimeout(() => {
							window.location.href = response.redirectUrl;
						}, 6000);
					}
				} else if (status === 400) {
					const grouppageUnsuccessfulSignupModal = document.getElementById('grouppage_unsuccessful_signup');

					if (grouppageUnsuccessfulSignupModal) {
						Modal
							.getOrCreateInstance(grouppageUnsuccessfulSignupModal)
							.show();
					}
				} else {
					const grouppageErrorSignupModal = document.getElementById('grouppage_error_signup');

					if (grouppageErrorSignupModal) {
						Modal
							.getOrCreateInstance(grouppageErrorSignupModal)
							.show();
					}
				}

				this.isSubmitting = false;
			});
	}

}

new GroupPage();